import styled from 'styled-components'

export const HighlightTextStyles = styled.span<{ color?: string }>`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  color: ${({ color, theme }) => color || theme.palette.info.main};
`
